var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 877.66,
    height: 816.53,
    viewBox: "0 0 877.66 816.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gh_logo",
    transform: "translate(-46.684 -83.354)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "path3777",
    cx: 92.912,
    cy: 95.366,
    rx: 92.912,
    ry: 95.366,
    transform: "translate(219.137 708.614)",
    fill: "#0094e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4586",
    d: "M503.934,91.338h62.781L538.046,235.045H500.305s-16.693-122.3-172.376-122.3S150.473,270.972,150.473,349.721,174.443,596.275,311.6,593.95c85.644-1.452,105.6-43.911,105.6-43.911L440.79,411.776H349.34V384.922H514.821l-34.475,169.11s-1.452,13.79-5.081,21.048-34.838,51.531-168.747,51.531S46.684,515.927,46.684,357.342,176.6,83.354,319.945,83.354c139.715,0,171.65,48.265,171.65,48.265Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4588",
    d: "M648.235,91.865l86.733,1.026s-54.914,170.387-89.3,307.415c-24.428,97.348-77.624,303.181-77.624,303.181h8.981s36.667-112.939,75.122-176.557c37.066-61.321,96.548-112.9,159.288-113.281,72.362-.444,88.273,55.427,88.273,96.484s-21.042,90.326-21.042,90.326L802.2,797.534s-16.837,55.173,5.645,66.718c56.967,29.253,99.05-99.05,99.05-99.05l17.449,4.106s-47.477,153.755-140.2,127.578c-60.825-17.173-40.088-98.7-40.088-98.7S798.931,649.53,831.453,547.6c5.907-18.515,18.016-98.28-43.623-98.28-53.887,0-117.774,73.793-146.266,135.232-56.187,121.161-95.458,300.615-95.458,300.615l-65.435,8.211Z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhLogo);
export default __webpack_public_path__ + "static/media/gh_logo.24814bc6c75b910d141e0fc940f36a9d.svg";
export { ForwardRef as ReactComponent };